import { AutoConfirmPage } from './pages/auto-confirm-page';
import { ConfirmCodePage } from './pages/confirm-code-page';
import { ForgotPasswordPage } from './pages/forgot-password';
import { PasswordSuccessPage } from './pages/password-success';
import { ResetPasswordPage } from './pages/reset-password';
import { SigninPage } from './pages/signin-page';
import { AzureADPage } from './pages/signin-page-azure';
import { SignupCompanyPage } from './pages/signup-company-page';
import { SignupPage } from './pages/signup-page';
import { JourneyTemplate } from './pages/templates/journey-template';

export const routes = [
  {
    name: 'signin',
    path: 'signin',
    page: <SigninPage />,
  },
  {
    name: 'signinAzure',
    path: 'signinazure',
    page: <AzureADPage />,
  },
  {
    name: 'signup',
    path: 'signup',
    page: <SignupPage />,
  },
  {
    name: 'setpasswordsuccess',
    path: 'setpasswordsuccess',
    page: <PasswordSuccessPage />,
  },
  {
    name: 'resetpassword',
    path: 'resetpassword',
    page: <ResetPasswordPage />,
  },
  {
    name: 'forgotpassword',
    path: 'forgotpassword',
    page: <ForgotPasswordPage />,
  },
  {
    name: 'templates',
    path: 'templates/:journeyId/',
    page: <JourneyTemplate />,
  },
  {
    name: 'signupCompany',
    path: 'signup/company',
    page: <SignupCompanyPage />,
  },
  {
    name: 'autoConfirm',
    path: 'signup/confirm',
    page: <AutoConfirmPage />,
  },
  {
    name: 'confirmCode',
    path: 'signup/code',
    page: <ConfirmCodePage />,
  },
] as const;
